frappe.ready(function () {
  window.item_code = $('p.product-code span[itemprop="name"]')
    .not(".product-item-code")
    .text()
    .trim();

  if (!window.item_code) {
    return;
  }

  frappe.call({
    type: "POST",
    method:
      "webshop.webshop.shopping_cart.product_info.get_product_info_for_website",
    args: {
      item_code: window.item_code,
    },
    callback: function (r) {
      if (r.message) {
        if (r.message.product_info.sales_uom) {
          updateUOM(r.message.product_info.sales_uom);
        }
      }
    },
  });
});

function updateUOM(newUOM) {
  const $container = $("div.item-cart.row.mt-2 div.col-md-12").first();
  $container.contents().each(function () {
    // Replace UoM in the case where 'Webshop Settings' > 'Show Price' is disabled
    if (this.nodeType === Node.TEXT_NODE) {
      const text = this.nodeValue;
      if (text.includes("UOM")) {
        this.nodeValue = text.replace(/(UOM\s*:\s*)(.+)/i, `$1${newUOM}`);
      }
    }
  });

  // Replace UoM in the case where 'Webshop Settings' > 'Show Price' is enabled
  $(".formatted-price").each(function () {
    const text = $(this).text();
    if (text.includes("/")) {
      $(this).text(
        text.replace(/(\/\s*)([^)\s]+)(\s*\)?\s*)$/, `$1${newUOM}$3`),
      );
    }
  });
}
